module.exports = "<!--  Copyright (C) 2016 to the present, Crestron Electronics, Inc.\r\n         All rights reserved.\r\n         No part of this software may be reproduced in any form, machine\r\n         or natural, without the express written consent of Crestron Electronics.-->\r\n<div [ngBusy]=\"busyLoading\"></div>\r\n <div id=\"worldView\"   ></div> \r\n    \r\n   \r\n \r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/src/app/features/dashboard/world-view-container/world-view-container.component.html
// module id = ../../../../../src/app/features/dashboard/world-view-container/world-view-container.component.html
// module chunks = main